import Rollbar from 'rollbar';

export const rollbar = new Rollbar({
  enabled: process.env.NODE_ENV === 'production',
  accessToken: 'e60ccaa7756d4331acf697e8e7e04375',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: window.location.host,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.REACT_APP_COMMIT_ID,
        guess_uncaught_frames: true,
      },
    },
  },
});
